import type { ConnectionState } from '@koridor/api-client';

export function ConnectionBanner({ state }: { state: ConnectionState }) {
  if (state === 'online') return null;
  const offline = state === 'offline';
  return (
    <div style={{
      position: 'fixed', top: 'calc(env(safe-area-inset-top, 0px) + 8px)', left: 12, right: 12, zIndex: 400,
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
      padding: '8px 14px', borderRadius: 'var(--radius-full)',
      background: offline ? 'var(--brick-500)' : 'var(--moss-500)', color: '#fff',
      fontFamily: 'var(--font-body)', fontSize: 13, fontWeight: 600, whiteSpace: 'nowrap',
      boxShadow: 'var(--shadow-lg)', animation: 'kor-rise var(--dur-base) var(--ease-out)',
    }}>
      {offline ? (
        <>
          <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#fff', animation: 'kor-pulse 1.1s infinite' }} />
          Нет сети · Переподключение…
        </>
      ) : (
        <><span>✓</span> Соединение восстановлено</>
      )}
    </div>
  );
}
